import { render, staticRenderFns } from "./DeliveryNoteList.vue?vue&type=template&id=655c3bb8&lang=pug&"
import script from "./DeliveryNoteList.vue?vue&type=script&lang=ts&"
export * from "./DeliveryNoteList.vue?vue&type=script&lang=ts&"
import style0 from "./DeliveryNoteList.vue?vue&type=style&index=0&id=655c3bb8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports